<template>
  <div class="status-chips" v-bind:class="[colorClass]">{{text}}</div>
</template>

<script>
  export default {
    name: 'status-chips',
    props: ['status'],
    computed: {
      colorClass: function () {
        return this.$store.state.statusColor[this.status]
      },
      text: function () {
        return this.$t('orders.status["' + this.status + '"]')
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';

  .status-chips {
    display: inline-block;
    font-size: 12px;
    color: $body-light;
    padding: 3px 7px;
    border-radius: 5px;

    &.in-progress {
      background-color: $success-light;
    }
    &.partial-shipment {
      background-color: $success-medium;
    }
    &.shipped {
      background-color: $success-strong;
    }
    &.canceled {
      background-color: $danger;
    }
  }
</style>



// WEBPACK FOOTER //
// StatusChips.vue?afa60336